import { getRandomUid } from 'utilities/uuid.service';
import { useEffect, useState } from 'react';
import useDebounce from 'hooks/useDebounce';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import useQuizzes from 'hooks/API/GET/useQuizzes';

function QuizSearch({ enableAPI, isMulti, values, handleChange, dependencies = {} }) {
  const { query = {}, classID, courseID } = dependencies;
  const [quizzes, setQuizzes] = useState([]);
  const [search, setSearch] = useState('');
  const [keyword, setKeyword] = useState('');

  const _id = getRandomUid();

  const { data, isLoading } = useQuizzes({
    enabled: enableAPI,
    classID,
    courseID,
    configs: { params: { mode: 'dropdown', keyword, ...query } },
  });

  useEffect(() => {
    if (data?.data) setQuizzes(data?.data || []);

    return () => {};
  }, [data?.data]);

  const __search = useDebounce(search, 1000);

  useEffect(() => {
    if (__search) setKeyword(__search);
  }, [__search]);

  return (
    <>
      <label htmlFor={_id}>Quiz *</label>
      <AsyncTypeahead
        id={_id}
        filterBy={() => true}
        isLoading={isLoading}
        labelKey="name"
        // minLength={3}
        onSearch={(query) => setSearch(query)}
        options={quizzes}
        placeholder="Search quiz..."
        selected={values}
        onChange={handleChange}
        renderMenuItemChildren={(option) => <>{option.name}</>}
        useCache={false}
      />
    </>
  );
}

QuizSearch.defaultProps = {
  values: [],
  isMulti: false,
  handleChange: () => {},
};

export default QuizSearch;
